/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'navigation/out-black': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><path pid="0" _fill="#fff" d="M0 0h34v34H0z"/><path pid="1" d="M29 15.63l-4.06-4.29h-2.29l3.25 3.43H15.8v1.72h10.1l-3.25 3.42h2.29z" _fill="#151716"/><path pid="2" d="M21.58 18.51v6H14V29l-9-4.47V4.94h16.58v7.54h-1.51v-6H8l6 3V23h6v-4.49z" _fill="#151716"/></g></g>'
  }
})
